<template>
  <d2-container>
    <template slot="header">
      <!-- <cpt @calculate="addNum"></cpt> -->
      <el-date-picker
          v-model="selectedTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"

          align="right"
          :default-time="['00:00:00', '23:59:59']"
          style="margin-top:5px;margin-right: 20px;"
      ></el-date-picker>
      <el-input
          @keyup.enter.native="getSearch"
          v-model="listQuery.orderId"
          style="width: 250px;margin-right: 20px;"
          class="filter-item"
          placeholder="请输入项目id"
          size="small"
          clearable
      ></el-input>
      <el-input
          @keyup.enter.native="getSearch"
          v-model="listQuery.accountId"
          style="width: 250px;margin-right: 20px;"
          class="filter-item"
          placeholder="请输入用户id"
          size="small"
          clearable
      ></el-input>
      <!-- <br> -->
      <el-select
          @keyup.enter.native="getSearch"
          v-model="listQuery.status"
          clearable
          placeholder="请选择项目状态"
          size="small"
          style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
      <el-button
          @click="getSearch"
          class="filter-item"
          type="primary"
          icon="search"
          size="small"
          style="margin-top:5px;"
      >搜索</el-button>
      <el-button
          @click="clearBoth"
          class="filter-item"
          type="success"
          icon="search"
          size="small"
          style="margin-top:5px;"
      >清空</el-button>

      <el-button
          @click="add"
          class="filter-item"
          type="primary"
          icon="add"
          size="small"
          style="margin-top:5px;"
      >新增</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="list"
    >
      <el-table-column type="expand">
        <template slot-scope="props">

          <el-table
              size="mini"
              :key="tableKey"
              border
              :data="props.row.projectItems"
              style="margin-left: 50px"
          >
            <el-table-column label="任务图标" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.icon" style="width: 80px; height: 80px; object-fit: cover" />
              </template>
            </el-table-column>
            <el-table-column label="任务名称" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="任务ID">
              <template slot-scope="scope">
                <span>{{ scope.row.themeId }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="产品内容">
              <template slot-scope="scope">
                <span>{{ scope.row.contentId }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="交付时间">
              <template slot-scope="scope">
                <span>{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 0" type="danger">未开始</el-tag>
                <el-tag v-if="scope.row.status === 1" type="warning">进行中</el-tag>
                <el-tag v-if="scope.row.status === 2" >已递交</el-tag>
                <el-tag v-if="scope.row.status === 3" type="success">商家已确认</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="更新时间">
              <template slot-scope="scope">
                <span>{{ scope.row.updateTime }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="备注" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{scope.row.remark}}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="项目名">
        <template slot-scope="scope">
          <span>{{ scope.row.productName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.productCover" style="width: 80px; height: 80px; object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="下单用户" width="160">

        <template slot-scope="scope">
          <el-tag v-if="scope.row.accountId=='0'">后台新增</el-tag>
          <popover-user-info
              v-else
             :id="scope.row.accountId"
          ></popover-user-info>
        </template>
      </el-table-column>
      <el-table-column align="center" label="子订单id">
        <template slot-scope="scope">
          <span>{{scope.row.orderItemId}}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="交付时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="danger">未开始</el-tag>
          <el-tag v-if="scope.row.status === 1" type="warning">进行中</el-tag>
          <el-tag v-if="scope.row.status === 2" >已递交</el-tag>
          <el-tag v-if="scope.row.status === 3" type="success">商家已确认</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="备注" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.remark}}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="addRemark(scope.row.id)"
            style="margin-top: 10px;"
          >备注</el-button>
          <el-button
              size="mini"
              type="info"
              @click="toInfo(scope.row.id)"
              style="margin-top: 10px;"
          >查看</el-button>
          <el-button  type="primary" size="mini" @click="editProject(scope.row.id)">编辑</el-button>
          <el-button  type="primary" size="mini" @click="shareProject(scope.row.id)">分享</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
    <el-dialog title="分享项目" :visible.sync="showShareDialog">
      <share-project v-if="showShareDialog" :id="selectedId" />
    </el-dialog>
  </d2-container>
</template>
<script>

import moment from 'moment/moment'
import { addRemark, getList } from '@/api/merchant/service/project'
import { getClockInTplOptions } from '@/api/demo/punchInActivityTpl'
import UserInfo from '@/components/users/userInfo.vue'
import PopoverUserInfo from '@/components/users/popoverUserInfo.vue'
import ShareProject from '@/components/project/ShareProject/index.vue'

export default {
  name: 'serviceProduct',
  components: { PopoverUserInfo, UserInfo, ShareProject },
  data () {
    return {
      showShareDialog: false,
      selectedId: '',
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      list: [],
      form: {
        color: '', // 名称
        word: '' // 关键词
      },
      listQuery: {
        accountId: '',
        createTimeEnd: '',
        createTimeStart: '',
        currentPage: 1,
        keyword: '',
        orderId: '',
        pageSize: 20,
        status: ''
      },
      selectedTime: [], // 时间
      payList: [
        {
          value: 0,
          label: '未支付'
        },
        {
          value: 1,
          label: '已支付'
        }
      ],
      statusList: [
        {
          value: 0,
          label: '已关闭'
        },
        {
          value: 1,
          label: '待支付'
        },
        {
          value: 2,
          label: '未支付取消'
        },
        {
          value: 3,
          label: '已退款'
        },
        {
          value: 4,
          label: '待确认'
        },
        {
          value: 5,
          label: '进行中'
        },
        {
          value: 6,
          label: '已完成'
        }
      ],
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
      if (to.path == '/merchant/service/project' && from.path == '/merchant/service/project/add') {
        this.getSearch(this.listQuery.currentPage)
      }
    }
  },
  methods: {
    clearBoth () {
      this.listQuery = {
        currentPage: 1,
        pageSize: 20,
        keyword: '',
        payStatus: '',
        status: '',
        accountId: '',
        orderId: ''
      }
      this.selectedTime == []
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    toInfo (id) {
      window.open(`/#/merchant/service/project/edit?id=${id}`)
    },
    userDedtails (id) {
      let that = this
      console.log('id', id)
      that.$router.push({
        path: '/demo/user/userDetails',
        query: {
          id: id
        }
      })
    },
    editProject (id) {
      this.$router.push({ path: '/merchant/service/project/info',
        query: { id: id } }
      )
    },
    shareProject (id) {
      this.showShareDialog = true
      this.selectedId = id
    },
    add () {
      this.$router.push({
        path: '/merchant/service/project/info'
      })
    },
    toAigc () {
      this.$router.push({
        path: '/merchant/service/project/aigc'
      })
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      this.getList()
    },
    getList (val) {
      let that = this
      var createTimeStart, createTimeEnd
      if (this.selectedTime == '' || this.selectedTime == null) {
        createTimeStart = ''
        createTimeEnd = ''
      } else {
        createTimeStart = moment(this.selectedTime[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        createTimeEnd = moment(this.selectedTime[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      this.listQuery.createTimeStart = createTimeStart
      this.listQuery.createTimeEnd = createTimeEnd
      getList(this.listQuery).then(res => {
        that.listLoading = true
        that.list = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    addRemark (id) {
      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        addRemark(id, value).then(res => {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.getSearch(this.listQuery.currentPage)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
